import { render } from "./Home.vue?vue&type=template&id=4cb413bd&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=4cb413bd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4cb413bd"

export default script